import React, { useState } from "react";

/**
 * SimilarProblemsModal — Modal chọn tùy chọn tạo bài tương tự.
 */
function SimilarProblemsModal({ open, onClose, onConfirm }) {
    const [count, setCount] = useState(3);
    const [difficulty, setDifficulty] = useState("equivalent");
    const [solutionMode, setSolutionMode] = useState("full");

    if (!open) return null;

    const handleConfirm = () => {
        onConfirm({ count, difficulty, solutionMode });
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
            <div
                className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-5"
                onClick={(e) => e.stopPropagation()}
                style={{ animation: "pimSlideUp 0.15s ease-out" }}
            >
                <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <span>📋</span> Tạo bài tương tự
                </h3>

                {/* Số lượng */}
                <div className="mb-3">
                    <label className="text-xs font-medium text-gray-700 mb-1.5 block">Số lượng bài</label>
                    <div className="flex gap-2">
                        {[3, 5, 10].map((n) => (
                            <button
                                key={n}
                                type="button"
                                onClick={() => setCount(n)}
                                className={`flex-1 py-2 text-sm font-medium rounded-lg border transition-colors ${count === n
                                        ? "border-red-500 bg-red-50 text-red-700"
                                        : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                            >
                                {n} bài
                            </button>
                        ))}
                    </div>
                </div>

                {/* Mức độ */}
                <div className="mb-3">
                    <label className="text-xs font-medium text-gray-700 mb-1.5 block">Mức độ</label>
                    <div className="flex gap-2">
                        {[
                            { id: "easy", label: "Dễ hơn" },
                            { id: "equivalent", label: "Tương đương" },
                            { id: "hard", label: "Khó hơn" },
                        ].map((d) => (
                            <button
                                key={d.id}
                                type="button"
                                onClick={() => setDifficulty(d.id)}
                                className={`flex-1 py-2 text-xs font-medium rounded-lg border transition-colors ${difficulty === d.id
                                        ? "border-red-500 bg-red-50 text-red-700"
                                        : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                            >
                                {d.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Lời giải */}
                <div className="mb-5">
                    <label className="text-xs font-medium text-gray-700 mb-1.5 block">Lời giải</label>
                    <div className="flex gap-2">
                        {[
                            { id: "full", label: "Chi tiết" },
                            { id: "answer_only", label: "Chỉ đáp án" },
                            { id: "none", label: "Không" },
                        ].map((s) => (
                            <button
                                key={s.id}
                                type="button"
                                onClick={() => setSolutionMode(s.id)}
                                className={`flex-1 py-2 text-xs font-medium rounded-lg border transition-colors ${solutionMode === s.id
                                        ? "border-red-500 bg-red-50 text-red-700"
                                        : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                                    }`}
                            >
                                {s.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Actions */}
                <div className="flex gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                    >
                        Hủy
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className="flex-1 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
                    >
                        Tạo bài
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SimilarProblemsModal;
